import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "@phosphor-icons/react";
import { toast } from "sonner";
import { api, useAuth } from "@/App";

export default function LoginPage() {
  const navigate = useNavigate();
  const { user, login } = useAuth();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) {
      navigate("/dashboard", { replace: true });
    }
  }, [user, navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!password.trim()) {
      toast.error("Ingresa la contraseña");
      return;
    }

    setLoading(true);
    try {
      const response = await api.post("/auth/login", { password });
      login(response.data.user);
      toast.success("Bienvenido a CauraTech");
      navigate("/dashboard", { replace: true });
    } catch (error) {
      const msg = error.response?.data?.detail;
      toast.error(typeof msg === "string" ? msg : "Error de autenticación");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex" style={{ backgroundColor: '#05152E' }}>
      {/* Left Panel - Branding */}
      <div className="hidden lg:flex lg:w-1/2 p-12 flex-col justify-between border-r" style={{ backgroundColor: '#05152E', borderColor: '#1A3A5C' }}>
        <div className="flex items-center gap-3">
          <img 
            src="/images/logo-dark.png" 
            alt="CauraTech" 
            className="h-20 w-auto"
          />
        </div>

        <div>
          <h1 className="text-5xl font-black text-white leading-tight mb-6">
            CÓDIGOS QR
            <br />
            LISTOS PARA
            <br />
            <span style={{ color: '#008AD8' }}>IMPRIMIR</span>
          </h1>
          <p className="text-lg max-w-md" style={{ color: '#A1A1AA' }}>
            Genera códigos QR de alta resolución para impresión de gran formato. 
            Exportación SVG, URLs dinámicas y analíticas detalladas.
          </p>
        </div>

        <div className="grid grid-cols-3 gap-4">
          {[
            { label: "SVG", desc: "Vector" },
            { label: "300", desc: "DPI" },
            { label: "H", desc: "Nivel ECC" },
          ].map((item) => (
            <div 
              key={item.label} 
              className="p-4 border transition-colors hover:border-[#008AD8]"
              style={{ borderColor: '#1A3A5C' }}
            >
              <p 
                className="text-3xl font-bold text-white"
                style={{ fontFamily: 'IBM Plex Mono, monospace' }}
              >
                {item.label}
              </p>
              <p className="text-xs uppercase tracking-wider" style={{ color: '#71717A' }}>
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Right Panel - Login */}
      <div className="flex-1 flex items-center justify-center p-8" style={{ backgroundColor: '#0A1F3D' }}>
        <div className="w-full max-w-md">
          {/* Mobile Logo */}
          <div className="lg:hidden flex items-center gap-3 mb-12">
            <img 
              src="/images/logo-dark.png" 
              alt="CauraTech" 
              className="h-16 w-auto"
            />
          </div>

          <div className="mb-8">
            <p className="uppercase text-[10px] tracking-[0.1em] font-medium mb-2" style={{ color: '#71717A' }}>Acceso</p>
            <h2 className="text-3xl font-black text-white">
              Ingresa tu contraseña
            </h2>
          </div>

          <form onSubmit={handleLogin} className="space-y-6">
            <div className="relative">
              <Lock size={20} weight="bold" className="absolute left-4 top-1/2 -translate-y-1/2" style={{ color: '#71717A' }} />
              <input
                data-testid="password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Contraseña"
                autoFocus
                className="w-full pl-12 pr-4 py-4 border-2 text-white focus:outline-none transition-colors placeholder:text-[#71717A]"
                style={{ borderColor: '#1A3A5C', backgroundColor: '#0D2847' }}
              />
            </div>

            <button
              data-testid="login-submit-btn"
              type="submit"
              disabled={loading}
              className="w-full py-4 bg-white font-semibold border-2 border-white hover:bg-[#F4F4F5] transition-colors disabled:opacity-50"
              style={{ color: '#003594', boxShadow: '4px 4px 0px 0px #008AD8' }}
            >
              {loading ? "Verificando..." : "Entrar"}
            </button>
          </form>

          <div className="mt-12 pt-8 border-t" style={{ borderColor: '#1A3A5C' }}>
            <p className="text-xs text-center" style={{ fontFamily: 'IBM Plex Mono, monospace', color: '#71717A' }}>
              Acceso restringido — CauraTech QRgen
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
